'use strict';

define('baseUrl',['jquery.amd'], function ($) {
  return window.nvtagDebug ?
    '' :
    $('script[src$="/at.js"], script[src*="/at.js?"]').attr('src').replace(/\/at\.js(.*)$/,'/');
});

